import React, { useState, Fragment, useContext } from 'react';
import logo from '../assets/images/endless-logo.png';
import notie from 'notie';
import { useNavigate } from "react-router-dom";
import SesionContexto from '../context/ContextoSesion';
import '../assets/css/notie.css';
import tools from '../js/tools2'

const Signin = () => {

    const { sesion, setSesion } = useContext(SesionContexto);
    const history = useNavigate();
    const [step, setStep] = useState(0);
    const [user, setUser] = useState('');
    // const handleSubmit, register;
    let errors = false;

    const loginAuth = async () => {
        let form = tools.getForm('form-login')
        let data = form.data

        tools.toolFetch({
            ruta: 'p_login',
            method: 'POST',
            body: { user: data.email, pass: data.password }
        }, (response) => {
            if (response.estado == 1) {
                setStep(1);
                errors = false
            }
            else {
                notie.alert({ type: 'error', text: `Invalid user or password, please verify your data.`, time: 2 });
                errors = true
            }
        })
    }

    const codeAuth = async () => {
        console.log('sesion de contexto', sesion);
        let form = tools.getForm('form-code')
        let data = form.data

        tools.toolFetch({
            ruta: 'p_code',
            method: 'POST',
            body: { code: data.codigo, user: user }
        }, (response) => {
            if (response.estado == 1) {
                notie.alert({ type: 'success', text: `Welcome ${response.resultado.nombre} ${response.resultado.apellidos}`, time: 2 });
                localStorage.setItem('auth', JSON.stringify({
                    nombre: response.resultado.nombre,
                    apellidos: response.resultado.apellidos,
                    correo: response.resultado.correo,
                    permisos: response.resultado.permisos,
                }));

                setSesion({
                    nombre: response.resultado.nombre,
                    apellidos: response.resultado.apellidos,
                    correo: response.resultado.correo,
                    permisos: response.resultado.permisos,
                });

                setTimeout(() => {
                    console.log('sesion de contexto, después de login', sesion);
                }, 5000)

                history(`/program`);
            }
            else {
                notie.alert({ type: 'error', text: `Codigo incorrecto, favor de verificar sus datos.`, time: 2 });
            }
        })
    }

    return (
        <div>
            <div className="page-wrapper">
                <div className="container-fluid p-0">
                    {/* <!-- login page start--> */}
                    <div className="authentication-main">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="auth-innerright">
                                    <div className="authentication-box">
                                        <div className="text-center">
                                            <img src={logo} width="200" alt="" /></div>
                                        <div className="card mt-4">
                                            <div className="card-body">
                                                {!step ?
                                                    <Fragment>
                                                        <div className="text-center">
                                                            <h6>Log in</h6>
                                                        </div>
                                                        <form className="theme-form" id='form-login' /* onSubmit={handleSubmit(onSubmit)} */>
                                                            <div className="form-group">
                                                                <label className="col-form-label pt-0">User</label>
                                                                <input className="form-control" type="text" name="email" id='email'
                                                                    // ref={register({ required: "Required" })}
                                                                    placeholder="email@dominio.com"
                                                                    value={user}
                                                                    onChange={(e) => setUser(e.target.value)}
                                                                />
                                                                <p className="text-danger">{errors && 'Enter your user'}</p>
                                                            </div>
                                                            <div className="form-group">
                                                                <label className="col-form-label">Password</label>
                                                                <input className="form-control" type="password" name="password" id='password'
                                                                    placeholder="*******"
                                                                    // ref={register({ required: "Required" })} 
                                                                />
                                                                <p className="text-danger">{errors && 'Enter your password'}</p>
                                                            </div>
                                                            <div className="form-group form-row mt-3 mb-0">
                                                                <button className="btn btn-primary btn-block" type="button" onClick={()=>{loginAuth()}}>LOG IN</button>
                                                            </div>
                                                        </form>
                                                    </Fragment>
                                                    :
                                                    <Fragment>
                                                        <div className="text-center">
                                                            <h6>We sent you a code </h6>
                                                            <p className="text-muted" >To continue please write the code we sent to your e-mail.</p>
                                                        </div>
                                                        <form className="theme-form" id='form-code' /* onSubmit={handleSubmit(onSubmit)} */>
                                                            <div className="form-group">
                                                                <input className="form-control text-center" type="text" name="codigo" id='codigo'
                                                                    // ref={register({ required: "Required" })}
                                                                />
                                                                <p className="text-danger">{errors && 'Enter the correct code'}</p>
                                                            </div>

                                                            <div className="form-group form-row mt-3 mb-0">
                                                                <button className="btn btn-primary btn-block" type="button" onClick={()=>{codeAuth()}}>CONTINUE</button>
                                                            </div>
                                                        </form>
                                                    </Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- login page end--> */}
                </div>
            </div>
        </div>
    );
};

export default Signin;